const SocialAcountsIcon = ({ color }: any) => {
  return (
    <svg width={22} height={22} viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.5 7.334a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zM5.5 13.75a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zM16.5 20.166a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zM7.875 12.385l6.26 3.648M14.127 5.967L7.875 9.615'
        strokeWidth={1.75}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default SocialAcountsIcon
